export const styles = {
  modalWrapper: {
    fontFamily: '"Open Sans", sans-serif',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },

  modalContent: {
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 8,
    textAlign: 'center',
    maxWidth: 500,
  },

  modalButton: {
    width: '60%',
    height: 30,
    border: '1px solid #ee4360',
    fontSize: 16,
    marginTop: 15,
    borderRadius: 6,
    color: 'white',
    backgroundColor: '#ee4360',
    cursor: 'pointer',
    zIndex: 2000,
    '& modalButton:hover': {
      color: '#ee4360',
      backgroundColor: 'white',
    },
  },

  modalH2: {
    marginBottom: 14,
    fontSize: 38,
  },

  modalText: {
    marginBottom: 6,
    fontSize: 20,
  },
}
